import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// @mui material components
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import Checkbox from '@mui/material/Checkbox';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import MDDateRange from 'components/MDDateRange';
import TableHeader from 'components/Table/TableHeader';

// Material Dashboard 2 PRO React examples
import Navbar from 'examples/Navbars/NavBar';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';

const initFind = {
  search: '',
  order_by: '',
  order_sort: 'asc',
  page: 1,
  perPage: 10,
  pageTotal: 0,
  period: 'ALL',
  branch: [],
  date_start: Func.dateTimeFirstMonth(),
  date_stop: Func.dateTimeEndMonth(),
};

function RpSaleCostBranchABC() {
  const mod = 'rp_sale_cost_branch_abc';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [find, setFind] = useState(initFind);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [cboBranch, setCboBranch] = useState([]);
  const [urlExcel, setUrlExcel] = useState('');
  const [excelLoading, setExcelLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: 'barcode', label: 'รหัส', align: 'left', sort: false },
    { id: 'name', label: 'ชื่อสินค้า', align: 'left', sort: false },
    // { id: "cost", label: "ต้นทุน", align: "right", sort: false },
    // { id: "profit", label: "กำไร", align: "right", sort: false },
    // { id: "profit_percent", label: "กำไร %", align: "right", sort: false },
    ...find.branch.flatMap((bid) => {
      const branch = cboBranch.find((b) => b.id === bid);
      const branchLabel = branch ? branch.shortcode : `branch_id_${bid}`;

      return [
        {
          id: `quantity_sale_${bid}`,
          label: `จำนวนขาย ${branchLabel}`,
          align: 'right',
          sort: false,
        },
        {
          id: `amount_sale_${bid}`,
          label: `ราคาขาย ${branchLabel}`,
          align: 'right',
          sort: false,
        },
        {
          id: `quantity_${bid}`,
          label: `จำนวนคงเหลือ ${branchLabel}`,
          align: 'right',
          sort: false,
        },
        {
          id: `abc_${bid}`,
          label: `ABC สาขา ${branchLabel}`,
          align: 'center',
          sort: false,
        },
      ];
    }),
    { id: 'unit_name', label: 'หน่วยนับ', align: 'center', sort: false },
    { id: 'cost', label: 'ทุนปัจจุบัน', align: 'center', sort: false },
    { id: 'cost_sell', label: 'ทุนฝ่ายขาย', align: 'center', sort: false },
    { id: 'division_name', label: 'ประเภท', align: 'left', sort: false },
    { id: 'category_name', label: 'หมวดสินค้า(Cat.)', align: 'left', sort: false },
    { id: 'subcategory_name', label: 'หมวดย่อย(Sup Cat.)', align: 'left', sort: false },
    { id: 'abc_class', label: 'ABCบริษัท', align: 'left', sort: false },
    { id: 'supplier_type_name', label: 'ชื่อประเภทเจ้าหนี้', align: 'left', sort: false },
    { id: 'supplier_code', label: 'รหัสเจ้าหนี้', align: 'left', sort: false },
    { id: 'supplier_name', label: 'ผู้จำหน่าย', align: 'left', sort: false },
    { id: 'credit_day', label: 'ระยะเวลาเครดิต', align: 'left', sort: false },
  ];

  const view = (data) => {
    setFind(data);
    setSearched(true);
    setLoading(true);
    setRecord([]);
    closeShow();

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      branch: data.branch,
      date_start: data.date_start,
      date_stop: data.date_stop,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);
        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const excel = () => {
    setExcelLoading(true);

    const params = new URLSearchParams();
    params.append('search', find.search);
    params.append('date_start', find.date_start);
    params.append('date_stop', find.date_stop);

    find.branch.forEach((branchId) => {
      params.append('branch[]', branchId);
    });

    const url = `${urlExcel}/download?${params.toString()}`;

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;

    iframe.onload = () => {
      setExcelLoading(false);
      document.body.removeChild(iframe);
    };

    iframe.onerror = () => {
      setExcelLoading(false);
      document.body.removeChild(iframe);
    };

    document.body.appendChild(iframe);

    setTimeout(() => {
      setExcelLoading(false);
    }, 10000);
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? 'desc' : 'asc' });
  };

  const setDateRange = (start, stop) => {
    setFind({
      ...find,
      date_start: Func.dateTimeFormat(start.toDate()),
      date_stop: Func.dateTimeFormat(stop.toDate()),
      page: 1,
    });
  };

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setCboBranch(result.branch);
        setUrlExcel(result.excel);
      } else {
        Func.exitApp();
      }
    });
  };

  const renderSearch = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDBox
              noValidate
              component='form'
              role='form'
              onSubmit={(e) => {
                e.preventDefault();
                view({ ...find, page: 1 });
              }}
            >
              <MDInput
                name='searchform'
                fullWidth
                value={find.search}
                type='search'
                onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>{t('element.search')} :</InputAdornment>
                  ),
                  autoComplete: 'off',
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDInput
              select
              fullWidth
              SelectProps={{
                multiple: true,
                renderValue: (selected) => {
                  if (selected.length === cboBranch.length) return 'ทั้งหมด';
                  return cboBranch
                    .filter((item) => selected.includes(item.id))
                    .map((item) => item.name)
                    .join(', ');
                },
              }}
              value={find.branch}
              onChange={(e) => {
                const { value } = e.target;

                if (value.includes('ALL')) {
                  const allSelected = find.branch.length === cboBranch.length;
                  setFind({
                    ...find,
                    branch: allSelected ? [] : cboBranch.map((item) => item.id),
                    page: 1,
                  });
                } else {
                  setFind({ ...find, branch: value, page: 1 });
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>{t('menu.branch')} :</InputAdornment>
                ),
              }}
            >
              <MenuItem value='ALL'>
                <Checkbox checked={find.branch.length === cboBranch.length} />
                ทั้งหมด
              </MenuItem>
              {cboBranch.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  <Checkbox checked={find.branch.indexOf(item.id) > -1} />
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <MDDateRange
              dateStart={find.date_start}
              dateStop={find.date_stop}
              callBack={setDateRange}
              closeDate={() => {}}
            />
          </Grid>
          <Grid item xs={12}>
            <MDBox display='flex' justifyContent='end' gap={1}>
              <MDButton
                variant='gradient'
                color='info'
                onClick={() => view({ ...find, page: 1 })}
                disabled={loading}
              >
                <Icon>search</Icon>&nbsp;ค้นหา
              </MDButton>
              {find.branch.length === 0 ? null : (
                <MDButton
                  variant='gradient'
                  color='success'
                  onClick={excel}
                  disabled={excelLoading}
                >
                  {excelLoading ? (
                    <>
                      <CircularProgress size={16} color='inherit' sx={{ mr: 1 }} />
                      Loading...
                    </>
                  ) : (
                    <>
                      <Icon>table_view</Icon>&nbsp;Excel
                    </>
                  )}
                </MDButton>
              )}
            </MDBox>
          </Grid>
        </Grid>
      </Card>
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} md={2} lg={1}>
            <MDButton
              variant='contained'
              color='dark'
              size='large'
              fullWidth
              sx={{ pt: 1.6, pb: 1.6 }}
              href='/report_power_bi'
            >
              <Icon>content_paste_search</Icon>
            </MDButton>
          </Grid>
          <Grid item xs={12} sm={9} md={10} lg={11}>
            {renderSearch()}
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ minHeight: 400 }}>
              <Table aria-label='datatable table'>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={initHeader.length} align='center'>
                        {searched ? 'ไม่พบข้อมูล' : 'กรุณาเลือกเงื่อนไขแล้วกดค้นหา'}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {record.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell align='left'>{row.barcode}</TableCell>
                      <TableCell align='left'>{row.name}</TableCell>
                      {find.branch.map((bid) => (
                        <React.Fragment key={`branch_${bid}`}>
                          <TableCell align='right'>
                            <MDBox>{Func.numberDisplay(row[`quantity_sale_${bid}`])}</MDBox>
                            <MDBox>{row.unit_name}</MDBox>
                          </TableCell>
                          <TableCell align='right'>
                            <MDBox>{Func.numberDisplay(row[`amount_sale_${bid}`])}</MDBox>
                          </TableCell>
                          <TableCell align='right'>
                            <MDBox>{Func.numberDisplay(row[`quantity_${bid}`])}</MDBox>
                            <MDBox>{row.unit_name}</MDBox>
                          </TableCell>
                          <TableCell align='center'>
                            <MDBox>{row[`abc_${bid}`]}</MDBox>
                          </TableCell>
                        </React.Fragment>
                      ))}
                      <TableCell align='center'>{row.unit_name || '-'}</TableCell>
                      <TableCell align='center'>{Func.numberDisplay(row.cost)}</TableCell>
                      <TableCell align='center'>{Func.numberDisplay(row.cost_sell)}</TableCell>
                      <TableCell align='left'>{row.division_name || '-'}</TableCell>
                      <TableCell align='left'>{row.category_name || '-'}</TableCell>
                      <TableCell align='left'>{row.subcategory_name || '-'}</TableCell>
                      <TableCell align='center'>{row.abc_class || '-'}</TableCell>
                      <TableCell align='left'>{row.supplier_type_name || '-'}</TableCell>
                      <TableCell align='center'>{row.supplier_code || '-'}</TableCell>
                      <TableCell align='left'>{row.supplier_name || '-'}</TableCell>
                      <TableCell align='center'>{row.credit_day || '-'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            {record.length === 0 ? null : (
              <Card sx={{ p: 2 }}>
                <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
                  <MDButton
                    variant={show ? 'contained' : 'outlined'}
                    color='dark'
                    onClick={openShow}
                  >
                    {t(`element.show_record`, { num: find.perPage })}&nbsp;
                    <Icon>keyboard_arrow_down</Icon>
                  </MDButton>
                  {renderShow}
                  <Pagination
                    count={pageTotal}
                    variant='outlined'
                    color='secondary'
                    showFirstButton
                    showLastButton
                    page={pageNo}
                    onChange={(e, p) => view({ ...find, page: p })}
                  />
                </MDBox>
              </Card>
            )}
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <MDBox>
      <Navbar route={[t(`menu.report_power_bi`), t(`menu.rp_sale_cost_branch_abc`)]} />
      {renderList()}
      {renderLoading()}
    </MDBox>
  );
}

export default RpSaleCostBranchABC;
